import { render } from "./BoardEdge.vue?vue&type=template&id=207c7b8d&ts=true"
import script from "./BoardEdge.vue?vue&type=script&lang=ts"
export * from "./BoardEdge.vue?vue&type=script&lang=ts"

import "./BoardEdge.vue?vue&type=style&index=0&id=207c7b8d&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__